module.exports = __webpack_public_path__ + "static/media/lr.12422cd4.svg";